module.exports = __webpack_public_path__ + "static/media/AssesmentImage.70620d22.jpeg";